import { Button, Divider, Form, Input, Modal } from "antd";
import { useState } from "react";
import { Post } from "../config/api/post";
import { RESET } from "../config/constants/api";
import { useSelector } from "react-redux";
import swal from "sweetalert";

const ChangePasswordModal = ({ passwordModal = false, setPasswordModal }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.user.userToken);
  const userData = useSelector((state) => state.user.userData);

  const onFinish = (values) => {
    if (values?.password !== values?.confirmPassword) {
      swal("Error", "Password and Confirm Password should match", "error");
      return;
    }
    let body = {
      email: userData.email,
      type: "USER",
      password: values?.password,
      oldPassword: values.oldPassword,
    };
    Post(RESET.changePassword, body, token)
      .then((response) => {
        if (response.status) {
          form.resetFields();
          swal("System Alert", response?.message, "success");
          setPasswordModal(false);
        }
      })
      .catch((err) => {
        console.log("Error", err);
        swal("Error", err?.response?.data?.message, "error");
      });
  };
  const handleClick = () => {
    setPasswordModal(false);
  };
  return (
    <div>
      <Modal
        centered
        open={passwordModal}
        footer={null}
        onCancel={() => setPasswordModal(false)}
      >
        <h3 className="font-tavi text-2xl text-customBlack max-sm:text-lg text-center my-4">
          Change Password
        </h3>
        <Divider />
        <div className="flex flex-col justify-center items-center bg-white my-4 px-8">
          <Form
            form={form}
            name="normal_login"
            onFinish={onFinish}
            layout="vertical"
            className="w-full"
          >
            <Form.Item
              name="oldPassword"
              label="Current Password"
              rules={[
                {
                  required: true,
                  message: "Please input current password!",
                },
                {
                  min: 8,
                  message:
                    "Password should be at least eight character with at least one numeric, one uppercase and one lowercase character. ",
                },
              ]}
            >
              <Input.Password
                placeholder="Enter Current Password"
                className="h-12 text-sm font-euclid bg-gray-100 "
                autoComplete={false}
              />
            </Form.Item>
            <Form.Item
              name="password"
              label="New Password"
              rules={[
                {
                  required: true,
                  message: "Please input new password!",
                },
              ]}
            >
              <Input.Password
                placeholder="Enter New Password"
                className="h-12 text-sm font-euclid bg-gray-100 "
                autoComplete={false}
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Confirm Password"
              rules={[
                {
                  required: true,
                  message: "Confirm your password!",
                },
              ]}
            >
              <Input.Password
                placeholder="Confirm Password"
                className="h-12 text-sm font-euclid bg-gray-100 "
                autoComplete={false}
              />
            </Form.Item>
            <Form.Item>
              <button
                htmlType="submit"
                className="uppercase bg-button py-4 w-full text-white rounded-lg text-sm font-bold max-sm:text-xs max-md:px-4 mt-6"
              >
                set password
              </button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default ChangePasswordModal;
